<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="absolute top-0 left-0 right-0 bottom-0 w-full overflow-hidden flex items-center text-center justify-center z-50" v-show="loading"><spinner line-fg-color="#922C49" size="55" :line-size="5"></spinner></div>
        <form id="form" v-if="!loading" @submit.prevent="submitForm" class="flex flex-col h-full" autocomplete="off">
            <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
                <template slot="title">{{ type }} Template</template>
            </page-header>

            <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>

            <div class="flex md:flex-row sm:flex-col flex-grow">
                <div class="md:w-3/4 sm:w-full px-4 sm:px-6 lg:px-6 bg-gray-200 border-r border-gray-400 pb-12" v-show="activeTab === 'details'">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-text class="col-span-8"
                                label="Name"
                                name="name"
                                placeholder="Name"
                                v-model="item.name"
                                rules="required"
                                :required="true"
                            />
                            <input-select class="col-span-4"
                                label="Type"
                                name="type_id"
                                placeholder="Type"
                                v-model="item.type_id"
                                return="value"
                                :options="options.templateTypes"
                            />
                            <!-- Options -->
                            <input-textarea v-if="typeName === 'SMS' || typeName === 'Supplier Message'"
                                class="col-span-12"
                                label="SMS Template"
                                name="sms_content"
                                placeholder="SMS Template"
                                ref="content_input"
                                v-model="item.content"
                                rows="10"
                            />
                            <div class="w-full block col-span-12 -mt-3">
                                <small :class="{'text-red-600': contentLength > 918}">Characters: {{ contentLength }} / 918</small>
                            </div>
                            <div class="flex flex-row -mt-3" v-if="typeName === 'SMS' || typeName === 'Supplier Message'">
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{first}')">
                                    First Name
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{last}')">
                                    Last Name
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{mobile}')">
                                    Member Mobile
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{address}')">
                                    Member Address
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{submission-id}')">
                                    Submission ID
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{status}')">
                                    Submission Status
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{amount}')">
                                    Submission Amount
                                </button>
                                <button type="button"
                                    class="bg-gray-300 border border-gray-400 py-1 px-4 text-xs whitespace-no-wrap mr-2"
                                    @click="insertCode('{supplier}')">
                                    Supplier Name
                                </button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
                <div class="md:w-1/4 sm:w-full px-4 sm:px-6 lg:px-6">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-toggle class="sm:col-span-12"
                                label="Active"
                                name="active"
                                v-model="item.active"
                                :required="false" />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
    import FormSetup from "../../../mixins/Tabs";
    import FormButtons from "../../../mixins/FormButtons";
    import axios from "axios";

    export default {
        name: "TemplateForm",
        props: {
            id: {required: false},
            type: {required: true},
            return: {required: false, default: '/configuration/templates'},
            page: {required: false, default: 'templates'}
        },
        mixins: [
            FormSetup,
            FormButtons
        ],
        data: function () {
            return {
                resource: 'templates',
                prefix: 'configuration',
                pageActions: {
                    buttons: [
                        {
                            label: 'Save',
                            icon: 'save',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'save',
                        },
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel',
                        }
                    ]
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    }
                ],
                startTab: null,
                loading: true,
                submitted: false,
                errorMessage: '',
                item: {},
                S3URL: process.env.VUE_APP_S3_URL,
                options: {
                    templateTypes: []
                }
            }
        },
        methods: {
            getData: function () {
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/templates/' + this.id, )
                    .then(response => {
                        this.item = response.data;

                        this.$Progress.finish();
                        this.loading = false;
                    })
                    .catch(() => {
                        this.$Progress.finish();
                        this.loading = false;
                    });
            },
            submitForm: function () {
                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    let _method;
                    let _url;

                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;

                    this.$store.commit('TOGGLE_BACKDROP', {open: true});
                    this.errorMessage = '';

                    if (this.id) {
                        _url = process.env.VUE_APP_API_URL + '/templates/' + this.id;
                        _method = 'PUT';
                    } else if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/templates/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/templates';
                        _method = 'POST';
                    }

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {
                        if (response.data.success) {
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                            this.$router.push('/configuration/templates');

                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });

                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
            insertCode(code){
                this.$nextTick(() => {
                    let textarea = this.$refs.content_input
                    let cursorPosition = textarea.$refs.sms_content.selectionStart

                    const content = textarea.$refs.sms_content.value

                    if (content && content !== '') {
                        const textBefore = content.substring(0, cursorPosition)
                        const textAfter = content.substring(cursorPosition, content.length)

                        textarea.$refs.sms_content.value = textBefore + code + ' ' + textAfter
                        this.item.content = textBefore + code + ' ' + textAfter
                    } else {
                        textarea.$refs.sms_content.value = code + ' '
                        this.item.content = code + ' '
                    }

                    textarea.$refs.sms_content.focus()
                    textarea.$refs.sms_content.blur()
                    textarea.$refs.sms_content.focus()
                })
            }
        },
        beforeMount() {
            if (this.$store.getters.templateTypes.length === 0){
                this.$store.dispatch('GET_TEMPLATE_TYPES').then(() => {
                    this.options.templateTypes = this.$store.getters.templateTypes.map(function (type) {
                        return { value: type.id, label: type.name };
                    });
                });
            } else {
                this.options.templateTypes = this.$store.getters.templateTypes.map(function (type) {
                    return { value: type.id, label: type.name };
                });
            }
        },
        mounted() {
            if (this.type === "New") {
                this.loading = false;
                this.$Progress.finish();
                // Se defaults here
            } else if (this.type === "Edit") {
                this.getData();
            }

            let windowLocationHash = window.location.hash.replace('#', '');

            if (windowLocationHash) {
                this.startTab = windowLocationHash;
            }
        },
        computed: {
            initialValue: function(){
                let output = {};

                if (this.item && this.item.type){
                    output['template_type'] = this.item.type.id;
                } else {
                    output['template_type'] = null;
                }

                return output;
            },
            typeName: function(){
                if (this.item.type_id) {
                    return this.options.templateTypes.find(type => {
                        return type.value === this.item.type_id
                    }).label
                }

                return null
            },
            contentLength: function () {
                if (this.item?.content) {
                    return this.item.content.length;
                }

                return 0;
            },
        }
    }
</script>

<style scoped>

</style>
